'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _asyncToGenerator = require('@babel/runtime-corejs3/helpers/asyncToGenerator');
var _regeneratorRuntime = require('@babel/runtime-corejs3/regenerator');
var request = require('../../request.js');
var version = require('../../version.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);

var createGraph = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(params) {
    var res, _res;
    return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return version.getVersionIsGTE410();
        case 2:
          if (!_context.sent) {
            _context.next = 7;
            break;
          }
          res = request.getAxiosInstance().post('/api/gsql-server/gsql/v1/schema/graphs', {
            VertexTypes: params.VertexTypes,
            EdgeTypes: params.EdgeTypes
          }, {
            params: {
              graphName: params.GraphName
            }
          });
          return _context.abrupt("return", res);
        case 7:
          _res = request.getAxiosInstance().post('/api/gsql-server/gsql/schema', params);
          return _context.abrupt("return", _res);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function createGraph(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.createGraph = createGraph;
